<template>
  <div class="corpo-pagina">

    <div id="modaltermse" class="modal danger-igotu">
      <div class="modal-content">
        <TermAndCondition />

      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModal" class="btn-small">{{ translation('btn.close') }}</a>

      </div>
    </div>

        <div id="modalprivacy" class="modal danger-igotu">
      <div class="modal-content">
        <p v-html="translation('new_privacy')"></p>

      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModalPrivacy" class="btn-small">{{ translation('btn.close') }}</a>

      </div>
    </div>

    <div v-if="!isAuthenticated">

          <div class="row row-text">
      <div class="col s12">
        <h4>{{ translation('item.sign.in') }}!</h4>
      </div>
    </div>

    <div class="row row-text">
      <div class="col s12">
        <p>{{ translation('Igotu.96') }}</p>
      </div>
    </div>

    <div class="row row-text">
      <div class="col s12">
        <p>{{ translation('Igotu.97') }}</p>
      </div>
    </div>
    </div>

    <div v-if="isAuthenticated">
          <div class="row row-text">
      <div class="col s12">
        <h4>{{ translation('item.my.account') }}</h4>
      </div>
    </div>
    </div>

    <div class="divider"></div>

    <div class="row">
      <div class="col s12 m4 l4">
        <label>
          <input class="with-gap" @change="onChange(1)" v-model="modelCompn.comanyId" value="1" type="radio"
            name="radioSet1" id="radio1" />
          <span>{{ translation('checkbox.registration.company') }}</span>
        </label>
      </div>

      <div class="col s12 m4 l4">
        <label>
          <input class="with-gap" @change="onChange(0)" v-model="modelCompn.comanyId" value="0" type="radio"
            name="radioSet1" id="radio2" />
          <span>{{ translation('checkbox.registration.private') }}</span>
        </label>
      </div>
      <div class="col s12 m4 l4"></div>
    </div>

    <!-- privato -->
    <div class="row" v-if="!modelCompn.is_company">

      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">account_circle</i>
          <input type="text" v-model="modelCompn.contact_name" class="validate required" id="contact_name_private" />
          <label for="contact_name_private">{{
            translation('field.company.contact.name')
            }}</label>
          <span id="error-message-contact_name_private" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">account_circle</i>
          <input type="text" v-model="modelCompn.contact_surname" class="validate required"
            id="contact_surname_private" />
          <label for="contact_surname_private">{{
            translation('field.company.contact.surname')
            }}</label>
          <span id="error-message-contact_surname_private" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">perm_data_setting</i>
          <input type="text" v-model="modelCompn.vat_number" class="validate required" id="vat_number_private" />
          <label for="vat_number_private">{{
            translation('filed.codice.fiscale.private')
            }}</label>
          <span id="error-message-vat_number_private" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>
    </div>

    <!-- aZIENDA-->
    <div v-if="modelCompn.is_company">
      <div class="row">
        <div class="col s12 m4 l4">
          <div class="input-field">
            <i class="material-icons prefix">business</i>
            <input type="text" v-model="modelCompn.name" class="validate required" id="name_company" />
            <label for="name_company">{{
              translation('field.company.name')
              }}</label>
            <span id="error-message-name_company" class="error-message-style nodipslay">
              {{ translation('filed.required.validation') }}
            </span>
          </div>
        </div>

        <div class="col s12 m4 l4">
          <div class="input-field">
            <i class="material-icons prefix">perm_data_setting</i>
            <input type="text" v-model="modelCompn.vat_number" class="validate required" id="vat_number_company" />
            <label for="vat_number_company">{{
              translation('field.company.vat')
              }}</label>
            <span id="error-message-vat_number_company" class="error-message-style nodipslay">
              {{ translation('filed.required.validation') }}
            </span>
          </div>
        </div>

        <div class="col s12 m4 l4">
          <div class="input-field">
            <i class="material-icons prefix">perm_data_setting</i>
            <input type="text" v-model="modelCompn.code_electronic_invoice" class="validate required"
              id="code_electronic_invoice_company" />
            <label for="code_electronic_invoice_company">{{
              translation('field.company.invoidce.code')
              }}</label>
            <span id="error-message-code_electronic_invoice_company" class="error-message-style nodipslay">
              {{ translation('filed.required.validation') }}
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m4 l4">
          <div class="input-field">
            <i class="material-icons prefix">contacts</i>
            <input type="text" v-model="modelCompn.contact_name" class="validate required" id="contact_name_company" />
            <label for="contact_name_company">{{
              translation('field.company.contact.name')
              }}</label>
            <span id="error-message-contact_name_company" class="error-message-style nodipslay">
              {{ translation('filed.required.validation') }}
            </span>
          </div>
        </div>
        <div class="col s12 m4 l4">
          <div class="input-field">
            <i class="material-icons prefix">contacts</i>
            <input type="text" v-model="modelCompn.contact_surname" class="validate required"
              id="contact_surname_company" />
            <label for="contact_surname_company">{{
              translation('field.company.contact.surname')
              }}</label>
            <span id="error-message-contact_surname_company" class="error-message-style nodipslay">
              {{ translation('filed.required.validation') }}
            </span>
          </div>
        </div>

        <div class="col s12 m4 l4">
          <div class="input-field">
            <i class="material-icons prefix">contact_phone</i>
            <input type="tel" v-model="modelCompn.contact_phone" class="validate required" id="contact_phone_company" />
            <label for="contact_phone_company">{{
              translation('field.contact.phone')
              }}</label>
            <span id="error-message-contact_phone_company" class="error-message-style nodipslay">
              {{ translation('filed.required.validation') }}
            </span>
          </div>
        </div>
      </div>

    </div>

    <!-- tUTTI -->
    <div class="row">
      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">location_city</i>
          <input type="text" v-model="modelCompn.city" class="validate required" id="city" />
          <label for="city">{{ translation('field.company.city') }}</label>
          <span id="error-message-city" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">location_searching</i>
          <input type="text" v-model="modelCompn.cap" class="validate required" id="cap" />
          <label for="cap">{{ translation('field.company.cap') }}</label>
          <span id="error-message-cap" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>
      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">location_on</i>
          <input type="text" v-model="modelCompn.address" class="validate required" id="address" />
          <label for="address">{{
            translation('field.company.address')
            }}</label>
          <span id="error-message-address" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s12 m4 l4">
        <!--div class="input-field" -->
          <!-- class="material-icons prefix" id="select-icon-country_company">language</i-->

          <!--select class="icons required js-select-due-filter" v-model="modelCompn.country_company" id="country_company">
            <option value="" disabled selected>
              {{ translation('filed.select.one') }}
            </option>
            <option v-for="r in contriesList" :key="r.uid" :value="r.uid" :data-icon="dataIcon(r.iso)"
              class="img-rounde-select">
              {{ r.name }}
            </option>
          </select -->

          <FilteredSelect
              id="country_company"
              v-model="modelCompn.country_company"
              :options="contriesList"
              label-key="name"
              value-key="uid"
              icon-key="iso"
              icon="language"
              :label="translation('filed.select.one')"
            />

          <!--label for="country_company">{{
            translation('filed.select.one')
          }}</label -->
          <span id="error-message-country_company" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        <!-- /div -->
      </div>

      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">local_phone</i>
          <input type="tel" v-model="modelCompn.phone" class="validate required" id="phone" />
          <label for="phone">{{ translation('field.company.phone') }}</label>
          <span id="error-message-phone" class="error-message-style nodipslay">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>
      <div class="col s12 m4 l4"></div>
    </div>

    <div class="row" v-if="!isAuthenticated">
      <div class="col s12 m4 l4">
        <div class="input-field">
          <i class="material-icons prefix">email</i>
          <input type="text" v-model="modelCompn.email" class="validate required" id="email" />
          <label for="email">{{ translation('field.account.email') }}</label>
          <span id="error-message-email" class="error-message-style nodipslay">
            {{ translation('filed.email.validation') }}
          </span>
        </div>
      </div>
      <div class="col s12 m4 l4"></div>
      <div class="col s12 m4 l4"></div>
    </div>

    <div class="row">
      <div class="col s12 m12 l12">
        <label>
          <input type="checkbox" class="" v-model="modelCompn.legal_privacy" value="" id="privacy1" />
          <span><a href="#!" @click="openModal">{{ translation('item.link.terms') }}</a></span><br />
          <span id="error-message-privacy.one" class="error-message-style nodipslay">
            {{ translation('obbligo.privacy.uno') }}
          </span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col s12 m12 l12">
        <label>
          <input type="checkbox" v-model="modelCompn.commercial_privacy" value="" id="privacy2" />
          <span><a href="#!" @click="openModalPrivacy">{{ translation('checkbox.privacy.two') }}</a></span><br />
          <span id="error-message-privacy.two" class="error-message-style nodipslay">
            {{ translation('obbligo.privacy.due') }}
          </span>

        </label>
      </div>
    </div>

    <div class="row">
      <div class="col s12 m12 l12">
        <label>
          <input type="checkbox" v-model="modelCompn.give_privacy" value="" id="privacy3" />
          <span>{{ translation('checkbox.privacy.tre') }}</span>

        </label>
      </div>
    </div>

    <div class="row"  v-if="!isAuthenticated">
    <div class="col s12 m4 l4">
      <RecaptchaWidget ref="captcha" />
    </div>
  </div>

    <div class="row">
      <div class="col s12 m12 l12">
        <a id="savecompnay" href="javascript:void(0)" v-if="!isAuthenticated" class="btn-large" @click="saveCompany()">
          <i class="material-icons left">save</i>
          {{ translation('item.sign.in') }}
        </a>
        <a href="javascript:void(0)" class="btn-large" v-if="isAuthenticated" @click="modifyCompany()">
          <i class="material-icons left">save</i>
          {{ translation('btn.modify') }}
        </a>

        <input v-if="isAuthenticated" v-model="modelCompn.uid" type="hidden" value="" />
      </div>
    </div>
  </div>
</template>

<script>
import countriesStore from '@/store/countries'
import apiService from '@/services/apiService.js'
import { companyModel } from '@/models/companyModel.js'
import translationStore from '@/store/translations'
import useAuthStore from '@/store/authStore.js'
import M from 'materialize-css'
import loadingStore from '@/store/loading'
import TermAndCondition from '@/components/TermAndCondition.vue'
import RecaptchaWidget from '@/components/RecaptchaWidget.vue'
import FilteredSelect from '@/components/FilteredSelect.vue'

export default {
  data () {
    return {
      contries: countriesStore,
      translationStore: translationStore,
      modelCompn: { ...companyModel },
      useAuthStore: useAuthStore,
      message_mail: { title: '', message: '', subject: '', btn: '' },
      modalTerms: null,
      modalPrivacy: null
    }
  },
  components: {
    TermAndCondition,
    RecaptchaWidget,
    FilteredSelect
  },
  computed: {
    translation () {
      return this.translationStore.getters.traduzione
    },
    contriesList () {
      return this.contries.getters.contries
    },
    isAuthenticated () {
      return this.useAuthStore.getters.isAuthenticated
    }
  },
  methods: {

    dataIcon (str) {
      // Assicurati che il percorso dell'immagine sia corretto
      return 'https://traduzioni.segreteriaorganizzativa.org/images/flags/1x1/' + str.toLowerCase() + '.svg'
    },

    initMaterializeForms () {
      this.$nextTick(() => {
        // Inizializza/Aggiorna tutti gli input e textarea
        if (M && M.updateTextFields) {
          M.updateTextFields()
        }

        // Inizializza/Aggiorna le select
        const selectElements = this.$el.querySelectorAll('select')

        if (M && M.FormSelect) {
          selectElements.forEach(selectEl => {
            // Distruggi l'istanza esistente prima di inizializzare per prevenire problemi
            if (selectEl.M_FormSelect) {
              selectEl.M_FormSelect.destroy()
            }
            // Inizializza la select
            M.FormSelect.init(selectEl, {
              classes: 'icon-flags-select' // Questa classe verrà applicata al contenitore della select
            })

            // Assicurati che Materialize re-renderizzi la select se il valore è già impostato
            // A volte è necessario un ulteriore $nextTick per assicurare che Materialize abbia finito il suo rendering
            if (selectEl.value && selectEl.M_FormSelect) {
              this.$nextTick(() => {
                selectEl.M_FormSelect.input.value = selectEl.options[selectEl.selectedIndex].textContent
                // Materialize Select può richiedere un "force update" visivo
                // Questi sono tentativi per forzarlo, prova a toglierli se funziona senza
                // selectEl.M_FormSelect.input.click();
                // selectEl.M_FormSelect.input.focus();
              })
            }
          })
        }
      })
    },

    async validateForm () {
      const fields = []
      let ris = true
      const required = document.querySelectorAll('.required')

      for (let i = 0; i < required.length; i++) {
        const el = required[i]
        const filedName = el.getAttribute('id')
        const val = el.value
        let err = this.$validateRequired(val)

        if (filedName === 'email') {
          err = this.$validateEmail(val)
        }

        if (!err) {
          fields.push({ field: filedName })
        }
      }

      const lvalid = fields.length
      if (lvalid >= 1) {
        ris = false
        this.blocForm(fields)
      }

      const errors = this.validatePrivacy()

      if (errors.length > 0) {
        ris = false
        errors.forEach(err => {
          const elPriv = document.getElementById(err)
          elPriv.classList.remove('nodipslay')
          elPriv.classList.add('invalid')
        })
      }

      return ris
    },

    validatePrivacy () {
      const errors = []

      const elPriv = document.getElementById('error-message-privacy.one')
      elPriv.classList.remove('invalid')
      elPriv.classList.add('nodipslay')

      const elPriv2 = document.getElementById('error-message-privacy.two')
      elPriv2.classList.remove('invalid')
      elPriv2.classList.add('nodipslay')

      if (this.modelCompn.commercial_privacy === false) {
        errors.push('error-message-privacy.one')
      }

      if (this.modelCompn.legal_privacy === false) {
        errors.push('error-message-privacy.two')
      }

      return errors
    },

    isVisibleComputedStyle (element) {
      const style = window.getComputedStyle(element)
      return style.display !== 'none' && style.visibility !== 'hidden'
    },

    blocForm (fields) {
      const allElements = document.querySelectorAll('*')
      const msgElements = document.querySelectorAll('.error-message-style')

      allElements.forEach(element => {
        if (element.classList.contains('invalid')) {
          element.classList.remove('invalid')
        }
        if (element.classList.contains('invalid-icon')) {
          element.classList.remove('invalid-icon')
        }
      })

      msgElements.forEach(element => {
        element.classList.add('nodipslay')
      })

      Object.values(fields).forEach(valore => {
        const elem = document.getElementById(valore.field)

        if (elem && this.isVisibleComputedStyle(elem)) {
          elem.classList.add('invalid')
          const prefixIcon = elem.previousElementSibling

          // Gestione specifica per gli elementi <select> di Materialize
          if (elem.tagName.toLowerCase() === 'select') {
            const selectWrapper = elem.parentNode.querySelector('.select-wrapper input.select-dropdown')
            if (selectWrapper) {
              selectWrapper.classList.add('invalid')

              const iconInvalid = document.getElementById('select-icon-' + valore.field)
              if (iconInvalid) iconInvalid.classList.add('invalid-icon')
            }
          }

          if (prefixIcon && prefixIcon.classList.contains('prefix')) {
            prefixIcon.classList.add('invalid-icon')
          }

          const msg = document.getElementById('error-message-' + valore.field)
          if (msg) {
            msg.classList.remove('nodipslay')
          }
        }
      })
    },

    async saveCompany () {
      loadingStore.commit('setLoading', true)

      const tokenTobot = this.$refs.captcha.getToken()
      if (!tokenTobot) {
        alert('Per favore conferma che non sei un robot!')
        loadingStore.commit('setLoading', false)
        return
      }

      try {
        const valid = await this.validateForm()
        if (valid) {
          const token = await apiService.getClientCredentialsToken()

          if (!token) {
            this.$router.push('/error')
          } else {
            const url = process.env.VUE_APP_URL_USER + '/company/create'
            this.modelCompn.buildata()

            this.message_mail.title = this.translation('mail.title.activation')
            this.message_mail.message = this.translation('mail.msg.activation')
            this.message_mail.subject = this.translation('subject.mail.activation')
            this.message_mail.btn = this.translation('btn.mail.activation')
            this.modelCompn.message_mail = this.message_mail

            const jsonCntry = await apiService.sendRequestWithBearer('POST', url, token, this.modelCompn)

            if (!jsonCntry) {
              this.$router.push('/error')
            } else {
              if (jsonCntry.error) {
                const fields = []
                const required = jsonCntry.details

                for (let i = 0; i < required.length; i++) {
                  const el = required[i]
                  const filedName = el.defaultMessage
                  fields.push({ field: filedName })
                }

                this.blocForm(fields)
                loadingStore.commit('setLoading', false)
                return
              }

              this.$router.push('/registration/finish')
            }
          }
        }
      } catch (error) {
        this.$router.push('/error?P=3')
      }
      loadingStore.commit('setLoading', false)
    },
    closeModal (e) {
      e.preventDefault()
      if (this.modalTerms) {
        this.modalTerms.close()
      }
    },
    async openModal (e) {
      e.preventDefault()
      if (this.modalTerms) {
        this.modalTerms.open()
      }
    },

    async openModalPrivacy (e) {
      e.preventDefault()
      if (this.modalPrivacy) {
        this.modalPrivacy.open()
      }
    },

    closeModalPrivacy (e) {
      e.preventDefault()
      if (this.modalPrivacy) {
        this.modalPrivacy.close()
      }
    },

    async modifyCompany () {
      loadingStore.commit('setLoading', true)
      try {
        const token = await apiService.getClientCredentialsToken()

        if (!token) {
          this.$router.push('/error')
        } else {
          const url = process.env.VUE_APP_URL_USER + '/company/modify'
          const jsonCntry = await apiService.sendRequestWithBearer('POST', url, token, this.modelCompn)
          if (!jsonCntry) {
            this.$router.push('/error')
          }

          useAuthStore.dispatch('modidyCompany', jsonCntry)

          this.$router.push('/modify/finish')
        }
      } catch (error) {
        this.$router.push('/error')
      }
      loadingStore.commit('setLoading', false)
    },

    onChange (id) {
      this.modelCompn.comanyId = id
      this.modelCompn.is_company = (id === 1)

      // Re-inizializza/aggiorna i campi di Materialize quando la visibilità dei campi cambia
      this.initMaterializeForms()
    },

    async populateSelect () {
      if (!countriesStore.getters.countrisUploded) {
        try {
          const token = await apiService.getClientCredentialsToken()
          if (!token) {
            this.$router.push('/error')
          } else {
            const url = process.env.VUE_APP_URL_USER + '/countries/all'
            const jsonCntry = await apiService.sendRequestWithBearer('GET', url, token)
            if (!jsonCntry) {
              this.$router.push('/error')
            } else {
              countriesStore.dispatch('caricaNazioni', jsonCntry)
            }
          }
        } catch (error) {
          this.$router.push('/error')
        }
      }
    }
  },

  async mounted () {
    await this.populateSelect()

    // Popola il modello se l'utente è autenticato
    if (this.isAuthenticated) {
      this.modelCompn.costruttore(this.useAuthStore.getters.userInfo)
    }

    // Inizializza/aggiorna i campi di Materialize DOPO che il DOM è stato popolato con i dati
    this.initMaterializeForms()

    const elems = document.getElementById('modaltermse')
    const privaModal = document.getElementById('modalprivacy')

    this.modalTerms = M.Modal.init(elems, {
      onCloseEnd: () => {
      },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })

    this.modalPrivacy = M.Modal.init(privaModal, {
      onCloseEnd: () => {
      },
      onOpenEnd: () => {
        loadingStore.commit('setLoading', false)
      }
    })

    loadingStore.commit('setLoading', false)
  },

  watch: {
    // Osserva l'intero oggetto modelCompn per rilevare cambiamenti profondi
    // Questo è fondamentale per Materialize per aggiornare gli input/select
    modelCompn: {
      handler (newVal, oldVal) {
        // Evita loop infiniti se la watch viene triggerata troppo spesso
        // Potresti voler essere più specifico se la watch triggera per ogni cambiamento
        this.initMaterializeForms()
      },
      deep: true // Osserva i cambiamenti all'interno dell'oggetto modelCompn
      // immediate: true // Potrebbe essere utile, ma mounted() dovrebbe già coprire l'iniziale
    },
    // Watcher per la lingua, se questa pagina contiene traduzioni che cambiano dinamicamente
    'translationStore.getters.linguaCorrente': {
      handler () {
        // Re-inizializza Materialize per aggiornare le label tradotte
        this.initMaterializeForms()
      },
      immediate: true // Inizializza al primo mount anche per la lingua
    },
    // Il contriesList non dovrebbe cambiare spesso, ma se cambiasse e influenzasse le select
    contriesList: {
      handler () {
        this.initMaterializeForms()
      },
      deep: true
    }
  }
}
</script>

<style>
/* Stili esistenti */
.input-field input[type='text']:focus+label,
.input-field input[type='tel']:focus+label,
.input-field input[type='email']:focus+label,
.input-field textarea:focus+label {
  color: #26a69a !important;
  /* Colore di focus per la label */
}

.input-field input[type='text']:focus,
.input-field input[type='tel']:focus,
.input-field input[type='email']:focus,
.input-field textarea:focus {
  border-bottom: 1px solid #26a69a !important;
  /* Colore di focus per la linea */
  box-shadow: 0 1px 0 0 #26a69a !important;
}

.input-materialize {
  padding-left: 40px !important;
  border-bottom: #272727 !important;
}

.correct-label {
  left: 20px !important;
}

.riposizionamento-select {
  position: absolute;
  inset: 0px auto auto 0px;
  margin: 0px;
  transform: translate(0px, 60px);
  display: block;
}

/* Stili aggiunti/modificati per Materialize Select e icone */
.select-wrapper input.select-dropdown {
  color: inherit;
  /* La classe 'icon-flags-select' viene applicata al .select-wrapper */
}

/* Stili per le bandiere all'interno della select */
/* Ispeziona il DOM con F12 per confermare le classi di Materialize (es. .circle) */
.select-wrapper.icon-flags-select img.circle {
  border-radius: 50%;
  /* Rende le bandiere tonde */
  width: 24px;
  /* Dimensione desiderata */
  height: 24px;
  margin-right: 8px;
  /* Spazio tra bandiera e testo */
  vertical-align: middle;
  /* Allinea verticalmente con il testo */
  border: 1px solid #eee;
  /* Un leggero bordo per distinguere */
}

/* Regola per il testo della select se non si vede bene */
.select-wrapper .select-dropdown {
  color: #333;
  /* Colore del testo della select, se Materialize lo rende invisibile */
}

/* Stili per i messaggi di errore */
.error-message-style {
  color: red;
  font-size: 0.8em;
  margin-top: 5px;
}

.nodipslay {
  display: none !important;
}

.invalid {
  border-bottom: 1px solid red !important;
  box-shadow: 0 1px 0 0 red !important;
}

.invalid-icon {
  color: red !important;
}
</style>
